module.exports = __webpack_public_path__ + "static/team-fbf3d6314034e06d4a101aae68a3649e.jpg";